module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-00.2.fc5ef543.jpg";